import {css} from 'lit'; export default css`.download-badge-img{width:160px}`;
    